import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { WithApp } from 'contexts/appContext';
import { wsFindBy } from 'services/WService.js';
import { wsGetAll } from 'services/WService';

export default WithApp(function ModalIndicadorPanettone(props) {
  const indicador = props.model;
  const periodo = moment(indicador.valueSearch?.Periodo).format('YYYY-MM');
  const [dataChanging, setDataChanging] = useState({});
  const [zones, setZones] = useState([]);
  const [groups, setGroups] = useState([]);

  function handleChange(field, value) {
    setDataChanging((prev) => ({ ...prev, [field]: value }));
  }

  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) {
      // Una zona por defCashier -> Ica / Nazca / Chincha.
      const uniqueZones = response.data.filter((zone, index, arr) => {
        return arr.findIndex((item) => item.defCashier === zone.defCashier) === index;
      });
      const filteredZones = uniqueZones.map(({ defCashier, ...zone }) => zone);
      setZones(filteredZones);
    }
  }

  async function listGroups() {
    // Grupos del mismo periodo; su detalle define los productos que suman el avance.
    let response = await wsFindBy('sale/panettone_group_products', {
      Periodo: indicador.valueSearch?.Periodo,
    });
    if (response.success) setGroups(response.data);
  }

  useEffect(() => {
    if (indicador.open) {
      listZones();
      listGroups();
      setDataChanging({
        zona: indicador.zona ?? null,
        sale_winter_panettone_group_product_id: indicador.sale_winter_panettone_group_product_id ?? null,
      });
    }
  }, [indicador.open]);

  return (
    <>
      <Modal
        title={`Indicador de Panetones`}
        model={indicador}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity='sale/panettone_indicators'
        dataForce={{
          zona: dataChanging.zona,
          sale_winter_panettone_group_product_id: dataChanging.sale_winter_panettone_group_product_id ?? null,
        }}
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="Periodo"
          margin="normal"
          defaultValue={periodo || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <Autocomplete
          disableClearable
          options={zones}
          getOptionLabel={(item) => `${item.description}`}
          renderInput={(params) => (
            <TextField {...params} label="Zona" margin="normal" fullWidth />
          )}
          onChange={(e, item) => { handleChange('zona', item?.code); }}
          value={zones.find((zone) => String(zone.code) === String(dataChanging.zona)) || null}
          style={{ flexGrow: 1, marginRight: '10px' }}
        />
        <TextField
          label="Código"
          fullWidth
          type="text"
          name="codigo"
          margin="normal"
          defaultValue={!!indicador ? indicador.codigo : ''}
          required
        />
        <Autocomplete
          options={groups}
          getOptionLabel={(item) => `${item.description}`}
          renderInput={(params) => (
            <TextField {...params} label="Grupo de productos (opcional)" margin="normal" fullWidth />
          )}
          onChange={(e, item) => { handleChange('sale_winter_panettone_group_product_id', item?.id ?? null); }}
          value={groups.find((g) => String(g.id) === String(dataChanging.sale_winter_panettone_group_product_id)) || null}
          style={{ flexGrow: 1, marginRight: '10px' }}
        />
        <TextField
          label="Descripción"
          fullWidth
          type="text"
          name="description"
          margin="normal"
          defaultValue={!!indicador ? indicador.description : ''}
          required
        />
        <TextField
          label="Cuota (unidades)"
          fullWidth
          type="number"
          name="quota"
          margin="normal"
          defaultValue={!!indicador ? indicador.quota : ''}
        />
      </Modal>
    </>
  );
});
